import modalTemplate from './modal.html';

angular.module('bl.basket').directive('blBasketClear', () => {
  return {
    restrict: 'AE',
    replace: true,
    scope: true,
    controller: blBasket
  };
});

class DialogController {

  constructor($scope, bbWidgetBasket, $uibModalInstance) {
    'ngInject';

    $scope.cancel = () => $uibModalInstance.close();

    $scope.ok = ($event) => {
      bbWidgetBasket.quickEmptyBasket();
      $uibModalInstance.close()
    };
  }
}

function blBasket($scope, $attrs, $rootScope, $location, $http, LoadingService, $uibModal) {

  $scope.clearBasket = () => {
    return $uibModal.open({
      templateUrl: modalTemplate.id,
      controller: DialogController,
      resolve: {}
    }).result;
  };

}


// WEBPACK FOOTER //
// ../src/public/javascripts/basket/clear-basket/clear_basket.controller.js